// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pre-selections[data-v-11e66156]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:2px}.pre-selections .selection-button[data-v-11e66156]{background:rgba(0,0,0,0);border:1px solid var(--border-color);padding:1px 4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
